import Axios from 'axios';

export default Axios.create({
	baseURL: 'http://localhost/cfc/api/',
	headers: { 'Content-Type': 'application/json' },
});
